import React from "react";
import Cinema from "./Cinema";
import SingleProduct from "./SingleProduct";
import MultipleProducts from "./MultipleProducts";
import BirthdayBoxForm from "./BirthdayBoxForm";
import OpenValueProduct from "./OpenValueProduct";
import ProductTypes from "../../../constants/productTypes";
var RedeemProductForm = function (_a) {
    var products = _a.products, deal = _a.deal, type = _a.type;
    switch (type) {
        case ProductTypes.BIRTHDAY_BOX:
            return React.createElement(BirthdayBoxForm, { deal: deal, products: products });
        case ProductTypes.CINEMA:
            return React.createElement(Cinema, { deal: deal, products: products });
        case ProductTypes.SINGLE_PRODUCT:
            return React.createElement(SingleProduct, { deal: deal, products: products });
        case ProductTypes.SINGLE_PRODUCT_QUANTITY:
            return React.createElement(SingleProduct, { deal: deal, products: products, allowMultipleQuantity: true });
        case ProductTypes.MULTIPLE_PRODUCTS:
            return React.createElement(MultipleProducts, { deal: deal, products: products });
        case ProductTypes.OPEN_VALUE_PRODUCT:
            return React.createElement(OpenValueProduct, { deal: deal, products: products });
        default:
            return null;
    }
};
export default RedeemProductForm;
